import * as React from 'react';
import { View, Text, StyleSheet } from "react-native";
import { GetProductInCart, GetProductMeta, GetProductStockCount } from '../../constants/Utils';

import { ProductContext } from '../../contexts/product/Store';
import { AnalyticsService } from '../../constants/Analytics';
import { AuthContext } from '../../contexts/auth/Store';
import FontStyles from '../../constants/FontStyle';
import Colors from '../../constants/Colors'
import ModelBackgroundImage from '../common/ModelBackgroundImage';
import StyledIcon from '../StyledIcon';
import { CartContext } from '../../contexts/cart/Store';
import { formatCurrency } from '../../utils/money';

const analytics = new AnalyticsService()

const ProductViewList = function ({ product, index }) {

    const authenticator = React.useContext(AuthContext)
    const buyer = authenticator.getUserData.buyerData

    const { product_state } = React.useContext(ProductContext)
    const [cart_state] = React.useContext(CartContext)

    const [meta, setMeta] = React.useState(null)
    const [inStock, setStock] = React.useState(undefined)
    const [inCart, setInCart] = React.useState(null)

    React.useEffect(() => {
        try {
            setMeta(GetProductMeta(product))
            setStock(GetProductStockCount(product))
            setInCart(GetProductInCart(cart_state, product?._id))
        } catch (e) {
            //
            console.log(e)
        }
        return () => { }
    }, [product, product_state, cart_state])

    return product
        ? <View style={[styles.itemCard, inCart && styles.inCartCard]}>
            <View style={styles.imageContainer}>
                <ModelBackgroundImage model={product} style={{ width: 72, height: 68 }} resizeMode="contain" />
            </View>
            <View style={styles.infoContainer}>
                <View style={[styles.productInfoContainer]}>
                    <Text style={[styles.productName]} numberOfLines={2}>{product.name}</Text>
                    <Text style={[styles.productMetric]}>{product.case_count} {product?.pricetag.mpu === product?.case_count && product?.pricetag.mpu === 1 ? product?.tags?.HIGHER_UNIT?.value : product?.tags?.LOWER_UNIT?.value + 's/' + product?.tags?.HIGHER_UNIT?.value}</Text>
                </View>
                <View style={[styles.priceContainer]}>
                    {
                        inStock
                            ? <>
                                <View style={{
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    alignItems: 'flex-end',
                                }}>
                                    <View>
                                        <Text style={styles.productPrice}>
                                            {formatCurrency(product.pricetag.price)}
                                        </Text>
                                        {
                                            meta
                                                ? meta.discount
                                                    ? <View style={styles.productDiscountContainer}>
                                                        <Text style={styles.productDiscountPrice}>{formatCurrency(parseFloat(meta.discount))}</Text>
                                                        <View style={styles.productDiscountBadge}>
                                                            <StyledIcon
                                                                iconName="ios-flash"
                                                                iconColor={Colors.successText}
                                                                iconOnly
                                                                size={12}
                                                            />
                                                            <Text style={styles.productDiscountBadgeText}>Save {Math.abs(Math.ceil(((parseFloat(meta.discount) - product.pricetag.price) / product.pricetag.price) * 100))}%</Text>
                                                        </View>
                                                    </View>
                                                    : meta.market_price
                                                        ? <Text style={styles.productOldPrice}>
                                                            <Text style={styles.productOldPriceStroke}>{formatCurrency(meta.market_price)}</Text>{` (Market Price)`}
                                                        </Text>
                                                        : null
                                                : null
                                        }
                                    </View>
                                    {
                                        inCart
                                            ? <View style={[styles.cartCount, { flexDirection: 'row' }]}>
                                                <StyledIcon
                                                    iconName="md-checkmark"
                                                    iconColor="white"
                                                    iconOnly
                                                    size={10}
                                                />
                                                <Text style={styles.cartCountText}>Added</Text>
                                            </View>
                                            : null
                                    }
                                </View>
                            </>
                            : inStock !== undefined
                                ? <Text style={styles.outOfStock}>Out of Stock</Text>
                                : <Text style={styles.outOfStock}>{` `}</Text>
                    }
                </View>
            </View>
        </View>
        : null
}

export default ProductViewList

const styles = StyleSheet.create({
    imageContainer: {
        paddingVertical: 4,
        minWidth: 72,
        minHeight: 68
    },
    infoContainer: {
        flexShrink: 1,
        flexGrow: 1,
    },
    productInfoContainer: {
        flexShrink: 1,
        paddingTop: 10,
        paddingHorizontal: 10
    },
    productName: {
        ...FontStyles.size13,
        ...FontStyles.lh18,
        ...FontStyles.normal,
        ...FontStyles.dark,
    },
    productMetric: {
        ...FontStyles.size13,
        ...FontStyles.lh15,
        ...FontStyles.normal,
        ...FontStyles.gray,
        marginTop: 2,
    },
    priceContainer: {
        flexGrow: 1,
        justifyContent: 'flex-end',
        // marginTop: 10,
        paddingVertical: 10,
        paddingLeft: 10,
    },
    productPrice: {
        ...FontStyles.size14,
        ...FontStyles.lh16,
        ...FontStyles.bold,
        ...FontStyles.dark,
    },
    productOldPrice: {
        ...FontStyles.size10,
        ...FontStyles.lh12,
        ...FontStyles.normal,
        color: Colors.dangerText,
        marginTop: 5,
    },
    productOldPriceStroke: {
        textDecorationLine: 'line-through'
    },
    productDiscountContainer: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 5,
    },
    productDiscountPrice: {
        ...FontStyles.size13,
        ...FontStyles.lh15,
        ...FontStyles.normal,
        color: Colors.greyColor,
        textDecorationLine: 'line-through',
        alignSelf: 'center'
    },
    productDiscountBadge: {
        flexDirection: 'row',
        alignSelf: 'center',
        backgroundColor: Colors.successBackground,
        paddingHorizontal: 8,
        paddingVertical: 4,
        borderRadius: 4,
        marginLeft: 4
    },
    productDiscountBadgeText: {
        ...FontStyles.size12,
        ...FontStyles.lh15,
        ...FontStyles.semibold,
        color: Colors.successText,
        marginLeft: 3,
    },
    itemCard: {
        backgroundColor: Colors.whiteColor,
        borderColor: '#E5EAF0',
        borderStyle: 'solid',
        borderTopWidth: 1,
        // borderRadius: 6,
        flex: 1,
        flexDirection: 'row',
        overflow: 'hidden',
        paddingHorizontal: 18,
    },
    outOfStock: {
        ...FontStyles.size14,
        ...FontStyles.lh16,
        ...FontStyles.bold,
        ...FontStyles.gray,
    },
    inCartCard: {
        // borderColor: Colors.greenColor + '4D',
        // borderWidth: 2,
    },
    cartCount: {
        ...FontStyles.white,
        ...FontStyles.semibold,
        ...FontStyles.size11,
        ...FontStyles.lh13,
        backgroundColor: Colors.greenColor,
        borderRadius: 16,
        paddingVertical: 4,
        paddingHorizontal: 6,
        alignSelf: 'flex-end'
    },
    cartCountText: {
        ...FontStyles.white,
        ...FontStyles.semibold,
        ...FontStyles.size11,
        ...FontStyles.lh13,
        alignSelf: 'flex-end',
        paddingLeft: 4
    }
})